import { Avatar } from 'antd';
import React from 'react';

const NetworkIcon = ({ network, size = 15, ...rest }) => {
  const iconPath = `/icons/networks/${network}.svg`;

  if (!network) {
    return null;
  }

  return network === 'all' ? null : <Avatar shape='square' size={size} src={iconPath} {...rest} />;
};

export default NetworkIcon;
